import type { CourseStatus } from "@/services/api/cronos/tracking/students/get-situation"

export function getProgressStatus(status: CourseStatus) {
  switch (status) {
    case "on_track":
      return {
        image:
          "https://storage.googleapis.com/tich-ai-prod-cdn/tich-universities/images/check_mark.png",
        label: "En orden",
        description: "¡Seguí así, vas por buen camino! 🚀",
        variant: "default",
        color: "bg-green-100",
      }
    case "at_risk":
      return {
        image:
          "https://storage.googleapis.com/tich-ai-prod-cdn/tich-universities/images/alert_mark.png",
        label: "En riesgo",
        description: "Podés ponerte al día, ¡vamos! ⏳",
        variant: "warning",
        color: "bg-yellow-100",
      }
    case "reschedule":
      return {
        image:
          "https://storage.googleapis.com/tich-ai-prod-cdn/tich-universities/images/alarm_mark.png",
        label: "Replanificar",
        description: "Es momento de reorganizar 📅",
        variant: "destructive",
        color: "bg-red-100",
      }
  }
}
